import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function Appeals() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Appeals policy"} />
      <MarkdownBlock markdown={TextBlocks.APPEALS_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
